import types from './types'

export const toggleSearchDrawer = (toggle = null) => ({type: types.CONTACTS_TOGGLE_SEARCH_DRAWER, toggle})
export const updateFilters = (filters) => ({type: types.CONTACTS_UPDATE_FILTERS, filters})
export const setContactList = (listName, listId) => ({type: types.CONTACTS_SET_CONTACT_LIST, listName, listId})
export const search = (phrase) => ({type: types.CONTACTS_SEARCH, phrase})

export const addRecent = (company, contact = null) => ({type: types.CONTACTS_RECENTS_ADD, company, contact})
export const removeRecent = (companyId, contactId = null) => ({
  type: types.CONTACTS_RECENTS_REMOVE,
  companyId,
  contactId,
})
export const setRecent = (companies) => ({type: types.CONTACTS_RECENTS_SET, companies})

export const toggleFieldSelector = (toggle) => ({type: types.CONTACTS_TOGGLE_FIELD_SELECTOR, toggle})
export const setFieldSelectMode = (mode) => ({type: types.CONTACTS_SET_FIELD_SELECT_MODE, mode})

export const toggleContactField = (key, visible) => ({type: types.CONTACTS_TOGGLE_CONTACT_FIELD, key, visible})
export const toggleCompanyField = (key, visible) => ({type: types.CONTACTS_TOGGLE_COMPANY_FIELD, key, visible})
export const toggleIndividualField = (key, visible) => ({type: types.CONTACTS_TOGGLE_INDIVIDUAL_FIELD, key, visible})

export const addFolderToDocuments = (folder) => ({type: types.CONTACTS_DOCUMENTS_ADD_FOLDER, folder})
export const setFolderDocumentsToRootDirectory = (folder) => ({type: types.CONTACTS_DOCUMENTS_SET_FOLDERS_TO_ROOT_DIRECTORY, folder})
export const removeFoldersAfterIndex = (index) => ({type: types.CONTACTS_DOCUMENTS_REMOVE_FOLDERS_AFTER_INDEX, index})

export const updateActivitiesFilters = (filters) => ({type: types.CONTACTS_ACTIVITIES_UPDATE_FILTERS, filters})
export const updateOpportunityFilters = (filters) => ({type: types.CONTACTS_OPPORTUNITIES_UPDATE_FILTERS, filters})
export const updateQuoteFilters = (filters) => ({type: types.CONTACTS_QUOTES_UPDATE_FILTERS, filters})
export const updateInvoiceFilters = (filters) => ({type: types.CONTACTS_INVOICES_UPDATE_FILTERS, filters})

export const bulkSubscribeOpen = (list) => ({type: types.CONTACTS_BULK_SUBSCRIBE_OPEN, list})
export const bulkSubscribeCancel = () => ({type: types.CONTACTS_BULK_SUBSCRIBE_CANCEL})
export const bulkSubscribeSetList = (list) => ({type: types.CONTACTS_BULK_SUBSCRIBE_SET_LIST, list})

export const updateSelectedInvoices = (selectedInvoices) => ({type: types.CONTACTS_UPDATE_SELECTED_INVOICES, selectedInvoices})

export const bulkSaveBegin = () => ({type: types.CONTACTS_BULK_SAVE_BEGIN})
export const bulkSaveUpdate = (current, total) => ({type: types.CONTACTS_BULK_SAVE_UPDATE, current, total})
export const bulkSaveFinish = () => ({type: types.CONTACTS_BULK_SAVE_FINISH})

// async request
export const loadContacts = ({
                                 search = null,
                                 index = null,
                                 filters = null,
                                 topLoading = false,
                                 bottomLoading = false,
                             } = {}) => ({
    type: types.CONTACTS_LOAD_CONTACTS_ATTEMPT,
    search,
    index,
    filters,
    topLoading,
    bottomLoading,
})
export const loadCompanies = ({
                                  search = null,
                                  index = null,
                                  filters = null,
                                  topLoading = false,
                                  bottomLoading = false,
                                  typeId = null,
                              } = {}) => ({
    type: types.CONTACTS_LOAD_COMPANIES_ATTEMPT,
    search,
    index,
    filters,
    topLoading,
    bottomLoading,
    typeId,
})
export const loadCompany = (companyId) => ({type: types.CONTACTS_DETAILS_COMPANY_LOAD_ATTEMPT, companyId})
export const loadActivities = (searchPhrase, companyId, contactId, filters) => ({
    type: types.CONTACTS_ACTIVITIES_LOAD_ATTEMPT,
    searchPhrase,
    companyId,
    contactId,
    filters,
})

export const loadDocumentsParentFolder = (companyId) => ({
    type: types.CONTACTS_DOCUMENTS_LOAD_PARENT_FOLDER_ATTEMPT,
    companyId,
})
export const loadDocuments = (folder) => ({type: types.CONTACTS_DOCUMENTS_LOAD_ATTEMPT, folder})
export const uploadDocuments = (documents) => ({type: types.CONTACTS_DOCUMENTS_UPLOAD_ATTEMPT, documents})
export const deleteDocuments = (documentIds) => ({type: types.CONTACTS_DOCUMENTS_DELETE_ATTEMPT, documentIds})

export const loadOpportunities = (searchPhrase, companyId, contactId, filters) => ({
    type: types.CONTACTS_OPPORTUNITIES_LOAD_ATTEMPT,
    searchPhrase,
    companyId,
    contactId,
    filters,
})
export const loadQuotes = (searchPhrase, companyId, contactId, filters) => ({
    type: types.CONTACTS_QUOTES_LOAD_ATTEMPT,
    searchPhrase,
    companyId,
    contactId,
    filters,
})

export const loadContact = (contactId) => ({type: types.CONTACTS_DETAILS_CONTACT_LOAD_ATTEMPT, contactId})
export const loadContactsSuccess = (data, index) => ({type: types.CONTACTS_LOAD_CONTACTS_SUCCESS, data, index})
export const loadContactFailure = (error, code) => ({type: types.CONTACTS_DETAILS_CONTACT_LOAD_FAILURE, error, code})

export const addContact = (contact, selectContact, callback) => ({
    type: types.CONTACTS_CONTACT_ADD_ATTEMPT,
    contact,
    selectContact,
    callback,
})
export const addContactSuccess = (data) => ({type: types.CONTACTS_CONTACT_ADD_SUCCESS, data})
export const addContactFailure = (error, code) => ({type: types.CONTACTS_CONTACT_ADD_FAILURE, error, code})

export const editContact = (contact, callback) => ({type: types.CONTACTS_CONTACT_EDIT_ATTEMPT, contact, callback})
export const editContactSuccess = (data) => ({type: types.CONTACTS_CONTACT_EDIT_SUCCESS, data})
export const editContactFailure = (error, code) => ({type: types.CONTACTS_CONTACT_EDIT_FAILURE, error, code})

export const deleteContact = (contactId, replaceId, companyId) => ({
    type: types.CONTACTS_CONTACT_DELETE_ATTEMPT,
    contactId,
    replaceId,
    companyId,
})
export const deleteContactSuccess = (contactId, replaceId, companyId) => ({
    type: types.CONTACTS_CONTACT_DELETE_SUCCESS,
    contactId,
    replaceId,
    companyId,
})
export const deleteContactFailure = (error, code) => ({type: types.CONTACTS_CONTACT_DELETE_FAILURE, error, code})

export const liveContact = (contactId) => ({type: types.CONTACTS_CONTACT_LIVE_ATTEMPT, contactId})
export const liveContactSuccess = (data, contactId) => ({type: types.CONTACTS_CONTACT_LIVE_SUCCESS, data, contactId})
export const liveContactFailure = (error, code) => ({type: types.CONTACTS_CONTACT_LIVE_FAILURE, error, code})

export const dormantContact = (contactId, replaceId) => ({
    type: types.CONTACTS_CONTACT_DORMANT_ATTEMPT,
    contactId,
    replaceId,
})
export const dormantContactSuccess = (data, contactId, replaceId) => ({
    type: types.CONTACTS_CONTACT_DORMANT_SUCCESS,
    data,
    contactId,
    replaceId,
})
export const dormantContactFailure = (error, code) => ({type: types.CONTACTS_CONTACT_DORMANT_FAILURE, error, code})

export const addCompany = (company, selectCompany, callback) => ({type: types.CONTACTS_COMPANY_ADD_ATTEMPT, company, selectCompany, callback})
export const editCompany = (company, callback) => ({type: types.CONTACTS_COMPANY_EDIT_ATTEMPT, company, callback})
export const deleteCompany = (companyId, replacementId = null) => ({type: types.CONTACTS_COMPANY_DELETE_ATTEMPT, companyId, replacementId})
export const liveCompany = (companyId) => ({type: types.CONTACTS_COMPANY_LIVE_ATTEMPT, companyId})
export const dormantCompany = (companyId) => ({ type: types.CONTACTS_COMPANY_DORMANT_ATTEMPT, companyId })
export const loadFieldOptions = (optionFields) => ({ type: types.CONTACTS_GET_FIELD_OPTIONS_ATTEMPT, optionFields })
export const loadExistingCompanies = (searchPhrase) => ({ type: types.CONTACTS_LOAD_EXISTING_COMPANIES_ATTEMPT, searchPhrase })
export const loadContactLists = () => ({ type: types.CONTACTS_LOAD_CONTACT_LISTS_ATTEMPT })
export const loadContactListCategory = (contactListCategoryId) => ({ type: types.CONTACTS_LOAD_CONTACT_LIST_CATEGORY, contactListCategoryId })
export const loadContactList = (contactListId) => ({ type: types.CONTACTS_LOAD_CONTACT_LIST_ATTEMPT, contactListId })
export const addLocation = (companyId, location) => ({ type: types.CONTACTS_LOCATION_ADD_ATTEMPT, companyId, location })
export const editLocation = (location) => ({ type: types.CONTACTS_LOCATION_EDIT_ATTEMPT, location })
export const deleteLocation = (locationId) => ({ type: types.CONTACTS_LOCATION_DELETE_ATTEMPT, locationId })
export const uploadCompanyImage = (companyId, file) => ({ type: types.CONTACTS_UPLOAD_COMPANY_IMAGE_ATTEMPT, companyId, file })
export const removeCompanyImage = (companyId) => ({ type: types.CONTACTS_REMOVE_COMPANY_IMAGE_ATTEMPT, companyId })
export const bulkSubscribe = (listId, subscribe) => ({ type: types.CONTACTS_BULK_SUBSCRIBE_ATTEMPT, listId, subscribe })
export const addContactMethod = (contactMethod) => ({ type: types.CONTACTS_CONTACT_METHOD_ADD_ATTEMPT, contactMethod })
export const editContactMethod = (contactMethod) => ({ type: types.CONTACTS_CONTACT_METHOD_EDIT_ATTEMPT, contactMethod })
export const deleteContactMethod = (id, name) => ({ type: types.CONTACTS_CONTACT_METHOD_DELETE_ATTEMPT, id, name })

// async successes
export const loadCompaniesSuccess = (data, index) => ({ type: types.CONTACTS_LOAD_COMPANIES_SUCCESS, data, index })
export const loadContactSuccess = (data) => ({ type: types.CONTACTS_DETAILS_CONTACT_LOAD_SUCCESS, data })
export const loadCompanySuccess = (data) => ({ type: types.CONTACTS_DETAILS_COMPANY_LOAD_SUCCESS, data })
export const loadActivitiesSuccess = (data) => ({ type: types.CONTACTS_ACTIVITIES_LOAD_SUCCESS, data })
export const loadDocumentsParentFolderSuccess = (data) => ({ type: types.CONTACTS_DOCUMENTS_LOAD_PARENT_FOLDER_SUCCESS, data })
export const loadDocumentsSuccess = (data) => ({ type: types.CONTACTS_DOCUMENTS_LOAD_SUCCESS, data })
export const uploadDocumentsSuccess = (data) => ({ type: types.CONTACTS_DOCUMENTS_UPLOAD_SUCCESS, data })
export const loadOpportunitiesSuccess = (data) => ({ type: types.CONTACTS_OPPORTUNITIES_LOAD_SUCCESS, data })
export const loadQuotesSuccess = (data) => ({ type: types.CONTACTS_QUOTES_LOAD_SUCCESS, data })

export const addCompanySuccess = () => ({ type: types.CONTACTS_COMPANY_ADD_SUCCESS })
export const editCompanySuccess = (data) => ({ type: types.CONTACTS_COMPANY_EDIT_SUCCESS, data })
export const deleteCompanySuccess = (companyId) => ({ type: types.CONTACTS_COMPANY_DELETE_SUCCESS, companyId })
export const liveCompanySuccess = (companyId) => ({ type: types.CONTACTS_COMPANY_LIVE_SUCCESS, companyId })
export const dormantCompanySuccess = (companyId) => ({ type: types.CONTACTS_COMPANY_DORMANT_SUCCESS, companyId })
export const getFieldOptionsSuccess = (data) => ({ type: types.CONTACTS_GET_FIELD_OPTIONS_SUCCESS, data })
export const loadExistingCompaniesSuccess = (data) => ({ type: types.CONTACTS_LOAD_EXISTING_COMPANIES_SUCCESS, data })
export const loadExistingCompanySuccess = (data) => ({ type: types.CONTACTS_LOAD_EXISTING_COMPANY_SUCCESS, data })
export const loadContactListsSuccess = (data) => ({ type: types.CONTACTS_LOAD_CONTACT_LISTS_SUCCESS, data })
export const loadContactListCategorySuccess = (data) => ({ type: types.CONTACTS_LOAD_CONTACT_LIST_CATEGORY_SUCCESS, data })
export const loadContactListSuccess = (data) => ({ type: types.CONTACTS_LOAD_CONTACT_LIST_SUCCESS, data })
export const addLocationSuccess = (data, contactId) => ({ type: types.CONTACTS_LOCATION_ADD_SUCCESS, data, contactId })
export const editLocationSuccess = (locationId, location) => ({ type: types.CONTACTS_LOCATION_EDIT_SUCCESS, locationId, location })
export const deleteLocationSuccess = (data) => ({ type: types.CONTACTS_LOCATION_DELETE_SUCCESS, data })
export const uploadCompanyImageSuccess = (data) => ({ type: types.CONTACTS_UPLOAD_COMPANY_IMAGE_SUCCESS, data })
export const removeCompanyImageSuccess = (companyId) => ({ type: types.CONTACTS_REMOVE_COMPANY_IMAGE_SUCCESS, companyId })
export const bulkSubscribeSuccess = (affectedContacts) => ({ type: types.CONTACTS_BULK_SUBSCRIBE_SUCCESS, affectedContacts })
export const addContactMethodSuccess = (data) => ({ type: types.CONTACTS_CONTACT_METHOD_ADD_SUCCESS, data })
export const editContactMethodSuccess = (data) => ({ type: types.CONTACTS_CONTACT_METHOD_EDIT_SUCCESS, data })
export const deleteContactMethodSuccess = (id, name) => ({ type: types.CONTACTS_CONTACT_METHOD_DELETE_SUCCESS, id, name })

// async failures
export const loadContactsFailure = (error, code) => ({ type: types.CONTACTS_LOAD_CONTACTS_FAILURE, error, code })
export const loadCompaniesFailure = (error, code) => ({ type: types.CONTACTS_LOAD_COMPANIES_FAILURE, error, code })
export const loadCompanyFailure = (error, code) => ({ type: types.CONTACTS_DETAILS_COMPANY_LOAD_FAILURE, error, code })
export const loadActivitiesFailure = (error, code) => ({ type: types.CONTACTS_ACTIVITIES_LOAD_FAILURE, error, code })
export const loadDocumentsParentFolderFailure = (error, code) => ({ type: types.CONTACTS_DOCUMENTS_LOAD_PARENT_FOLDER_FAILURE, error, code })
export const loadDocumentsFailure = (error, code) => ({ type: types.CONTACTS_DOCUMENTS_LOAD_FAILURE, error, code })
export const uploadDocumentsFailure = (error, code) => ({ type: types.CONTACTS_DOCUMENTS_UPLOAD_FAILURE, error, code })
export const loadOpportunitiesFailure = (error, code) => ({ type: types.CONTACTS_OPPORTUNITIES_LOAD_FAILURE, error, code })
export const loadQuotesFailure = (error, code) => ({ type: types.CONTACTS_QUOTES_LOAD_FAILURE, error, code })

export const addCompanyFailure = (error, code) => ({ type: types.CONTACTS_COMPANY_ADD_FAILURE, error, code })
export const editCompanyFailure = (error, code) => ({ type: types.CONTACTS_COMPANY_EDIT_FAILURE, error, code })
export const deleteCompanyFailure = (error, code) => ({ type: types.CONTACTS_COMPANY_DELETE_FAILURE, error, code })
export const liveCompanyFailure = (error, code) => ({ type: types.CONTACTS_COMPANY_LIVE_FAILURE, error, code })
export const dormantCompanyFailure = (error, code) => ({ type: types.CONTACTS_COMPANY_DORMANT_FAILURE, error, code })
export const getFieldOptionsFailure = (error, code) => ({ type: types.CONTACTS_GET_FIELD_OPTIONS_FAILURE, error, code })
export const loadExistingCompaniesFailure = (error, code) => ({ type: types.CONTACTS_LOAD_EXISTING_COMPANIES_FAILURE, error, code })
export const loadExistingCompanyFailure = (error, code) => ({ type: types.CONTACTS_LOAD_EXISTING_COMPANY_FAILURE, error, code })
export const loadContactListsFailure = (error, code) => ({ type: types.CONTACTS_LOAD_CONTACT_LISTS_FAILURE, error, code })
export const loadContactListCategoryFailure = (error, code) => ({ type: types.CONTACTS_LOAD_CONTACT_LIST_CATEGORY_FAILURE, error, code })
export const loadContactListFailure = (error, code) => ({ type: types.CONTACTS_LOAD_CONTACT_LIST_FAILURE, error, code })
export const addLocationFailure = (error, code) => ({ type: types.CONTACTS_LOCATION_ADD_FAILURE, error, code })
export const editLocationFailure = (error, code) => ({ type: types.CONTACTS_LOCATION_EDIT_FAILURE, error, code })
export const deleteLocationFailure = (error, code) => ({ type: types.CONTACTS_LOCATION_DELETE_FAILURE, error, code })
export const uploadCompanyImageFailure = (error, code) => ({ type: types.CONTACTS_UPLOAD_COMPANY_IMAGE_FAILURE, error, code })
export const removeCompanyImageFailure = (error, code) => ({ type: types.CONTACTS_REMOVE_COMPANY_IMAGE_FAILURE, error, code })
export const bulkSubscribeFailure = (error, code) => ({ type: types.CONTACTS_BULK_SUBSCRIBE_FAILURE, error, code })
export const addContactMethodFailure = (error, code) => ({ type: types.CONTACTS_CONTACT_METHOD_ADD_FAILURE, error, code })
export const editContactMethodFailure = (error, code) => ({ type: types.CONTACTS_CONTACT_METHOD_EDIT_FAILURE, error, code })
export const deleteContactMethodFailure = (error, code) => ({ type: types.CONTACTS_CONTACT_METHOD_DELETE_FAILURE, error, code })

export const toggleContactDetailsVisibility = () => ({type: types.CONTACTS_TOGGLE_CONTACT_DETAILS_VISIBILITY})

export const toggleCompanyContactsShowDormants = (showDormants) => ({type: types.CONTACTS_COMPANY_CONTACTS_TOGGLE_DORMANTS, showDormants})

export default {
  updateFilters,
  setContactList,
  search,
  addRecent,
  removeRecent,
  setRecent,
  toggleContactField,
  toggleCompanyField,
  toggleIndividualField,
  addFolderToDocuments,
  setFolderDocumentsToRootDirectory,
  removeFoldersAfterIndex,
  updateOpportunityFilters,
  updateQuoteFilters,
  updateInvoiceFilters,
  bulkSubscribeOpen,
  bulkSubscribeCancel,
  bulkSubscribeSetList,
  updateSelectedInvoices,
  loadContacts,
  loadCompanies,
  loadContact,
  loadCompany,
  loadActivities,
  loadDocumentsParentFolder,
  loadDocuments,
  uploadDocuments,
  loadOpportunities,
  loadQuotes,
  addContact,
  editContact,
  deleteContact,
  liveContact,
  dormantContact,
  addCompany,
  editCompany,
  deleteCompany,
  liveCompany,
  dormantCompany,
  loadFieldOptions,
  loadExistingCompanies,
  loadContactLists,
  loadContactListCategory,
  loadContactList,
  addLocation,
  editLocation,
  deleteLocation,
  uploadCompanyImage,
  removeCompanyImage,
  bulkSubscribe,
  addContactMethod,
  editContactMethod,
  deleteContactMethod,
  loadContactsSuccess,
  loadCompaniesSuccess,
  loadContactSuccess,
  loadCompanySuccess,
  loadActivitiesSuccess,
  loadDocumentsParentFolderSuccess,
  loadDocumentsSuccess,
  uploadDocumentsSuccess,
  loadOpportunitiesSuccess,
  loadQuotesSuccess,
  addContactSuccess,
  editContactSuccess,
  deleteContactSuccess,
  liveContactSuccess,
  dormantContactSuccess,
  addCompanySuccess,
  editCompanySuccess,
  deleteCompanySuccess,
  liveCompanySuccess,
  dormantCompanySuccess,
  getFieldOptionsSuccess,
  loadExistingCompaniesSuccess,
  loadExistingCompanySuccess,
  loadContactListsSuccess,
  loadContactListCategorySuccess,
  loadContactListSuccess,
  addLocationSuccess,
  editLocationSuccess,
  deleteLocationSuccess,
  uploadCompanyImageSuccess,
  removeCompanyImageSuccess,
  bulkSubscribeSuccess,
  addContactMethodSuccess,
  editContactMethodSuccess,
  deleteContactMethodSuccess,
  loadContactsFailure,
  loadCompaniesFailure,
  loadContactFailure,
  loadCompanyFailure,
  loadActivitiesFailure,
  loadDocumentsParentFolderFailure,
  loadDocumentsFailure,
  uploadDocumentsFailure,
  loadOpportunitiesFailure,
  loadQuotesFailure,
  addContactFailure,
  editContactFailure,
  deleteContactFailure,
  liveContactFailure,
  dormantContactFailure,
  addCompanyFailure,
  editCompanyFailure,
  deleteCompanyFailure,
  liveCompanyFailure,
  dormantCompanyFailure,
  getFieldOptionsFailure,
  loadExistingCompaniesFailure,
  loadExistingCompanyFailure,
  loadContactListsFailure,
  loadContactListCategoryFailure,
  loadContactListFailure,
  addLocationFailure,
  editLocationFailure,
  deleteLocationFailure,
  uploadCompanyImageFailure,
  removeCompanyImageFailure,
  bulkSubscribeFailure,
  addContactMethodFailure,
  editContactMethodFailure,
  deleteContactMethodFailure,
}
